import React from 'react';
import './Contact.css';

import backgroundImage from '../../assets/images/logo.png';

const Contact = () => {
	return (
		<main className="Contact TextShadow">
			<div className="Contact__Container">
				<div className="Contact__GridContainer">
					<div className="Contact__Heading">
						Thank you for your interest!
					</div>
					<div className="Contact__Details">
						<div>
							Please contact me for all purchases and wholesale
							enquiries.
						</div>
						<div className="Contact__DetailsGrid">
							<p className="Contact__DetailsGridElement">Email</p>
							{/* <p>:</p> */}
							<p>silvergull2@bigpond.com</p>
							<br></br>
							<p className="Contact__DetailsGridElement">
								Mobile
							</p>
							{/* <p>:</p> */}
							<p>0406 212 063</p>
							<br></br>
							<p className="Contact__DetailsGridElement">
								Instagram
							</p>
							{/* <p>:</p> */}
							<p>aspectsofnature8</p>
						</div>
						<img
							className="Contact__LogoImage Shadow--Lowered"
							src={backgroundImage}
						/>
					</div>
				</div>
			</div>
		</main>
	);
};

export default Contact;
